export const BRAND = "Lunessa Spa Masaj";
export const SLOGAN = "Sivas’ta Huzur ve Yenilenmenin Adresi";
export const PHONE_DISPLAY = "0535 795 20 58";
export const TEL = "tel:+905357952058";
export const WA =
  "https://wa.me/905357952058?text=Merhaba%20Lunessa%20Spa%20Masaj%2C%20randevu%20ve%20hizmetleriniz%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.";
export const waFor = (service) =>
  `https://wa.me/905357952058?text=${encodeURIComponent(
    `Merhaba Lunessa Spa Masaj, ${service} hizmetiniz için randevu ve bilgi almak istiyorum.`
  )}`;
export const IG_HANDLE = "@lunessaspamasaj";
export const IG = "https://instagram.com/lunessaspamasaj";
export const ADDRESS = "Kızılırmak, 27. Sokak No:2B, 58010 Merkez/Sivas";


export const MAPS_DIR = "https://share.google/bbqwe4TfqoUGi3R3K";

export const NAV = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/masaj-hizmetleri", label: "Hizmetlerimiz" },
  { to: "/sivas-masaj-salonu", label: "Sivas Masaj Salonu" },
  { to: "/sivas-masaj", label: "Sivas Masaj" },
  { to: "/sivas-spa", label: "Sivas Spa" },
  { to: "/hediye-ceki", label: "Hediye Çeki" },
  { to: "/galeri", label: "Galeri" },
  { to: "/iletisim", label: "İletişim" },
];

export const FOOTER_LINKS = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/sivas-masaj-salonu", label: "Sivas Masaj Salonu" },
  { to: "/sivas-masaj", label: "Sivas Masaj" },
  { to: "/sivas-spa", label: "Sivas Spa" },
  { to: "/sivas-spa-merkezi", label: "Sivas Spa Merkezi" },
  { to: "/masaj-hizmetleri", label: "Masaj Hizmetleri" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/galeri", label: "Galeri" },
  { to: "/yorumlar", label: "Misafir Yorumları" },
  { to: "/hediye-ceki", label: "Hediye Çeki" },
  { to: "/iletisim", label: "İletişim" },
];

export const DEFAULT_SETTINGS = {
  logo_url: "/images/lunessa-logo.webp",
  hero_url: "/images/lunessa-sivas-spa-masaj-hero.webp",
  campaign_active: true,
  campaign_badge: "%20 İndirim",
  campaign_text: "Tüm paketlerimizde %20 indirim",
  site_url: "https://lunessamasajsalonu.com",
  ga4_id: "",
  gtm_id: "",
  meta_pixel_id: "",
  gsc_verification: "",
  ticker_text: "",
  working_hours: "Her gün 10:00 – 23:00",
  google_rating: "4.9",
  google_review_count: "100+",
  google_reviews_url: "https://share.google/bbqwe4TfqoUGi3R3K",
  google_write_url: "https://share.google/bbqwe4TfqoUGi3R3K",
  map_lat: 39.73546,
  map_lng: 37.02419,
};
